import './QuestEmptyShield.css'

interface QuestEmptyShieldProps {
  /** Rendered width in px; height derives from the real club-shield artwork's
   * aspect ratio (130:164, src/assets/club-shields/*.svg) so the outline
   * matches their silhouette exactly. */
  size?: number
  className?: string
}

// Same viewBox + outline path as the real club-shield SVGs (e.g.
// src/assets/club-shields/ARS.svg) so an empty pick slot reads as "a shield
// with no crest in it" rather than a generic dashed box.
const SHIELD_OUTLINE = 'M8,8 H122 V84 C122,116 98,142 65,156 C32,142 8,116 8,84 Z'

function QuestEmptyShield({ size = 60, className }: QuestEmptyShieldProps) {
  const height = Math.round(size * (164 / 130))
  return (
    <svg
      className={`quest-empty-shield${className ? ` ${className}` : ''}`}
      width={size}
      height={height}
      viewBox="0 0 130 164"
      role="img"
      aria-hidden="true"
    >
      <path
        d={SHIELD_OUTLINE}
        className="quest-empty-shield__outline"
        fillOpacity={0.1}
        strokeWidth={4}
        strokeDasharray="7 7"
      />
    </svg>
  )
}

export default QuestEmptyShield
